import React, {useContext, useEffect, useRef, useState} from 'react';
import {PAContext} from "../../../Services/PAContext";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import {
    Avatar,
    Button,
    Card,
    CardContent, CardHeader,
    CardMedia,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Menu, MenuItem, MenuList,
    TextField, Tooltip
} from "@mui/material";
import Box from "@mui/material/Box";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {formatName, stringAvatar, stringToColor} from "../../Helpers/TextStyling";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Meal from "../../../MasterEventObjects/Meal";
import {useNavigate} from "react-router-dom";
import Activity from "../../../MasterEventObjects/Activity";
import Lodging from "../../../MasterEventObjects/Lodging";
import Message from "../../../MasterEventObjects/Message";
import IdeaComment from "../../../MasterEventObjects/IdeaComment";



function IdeasCard({eventIdea, setEventIdea, deleteEventIdea, setCurrentFeature}){

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject} = usePA_GlobalStore();

    const { dataArray, sendSocketMessage } = useContext(PAContext);
    const { Account, SampleAttendees, authenticated } = dataArray;

    const [dbContacts, setDbContacts] = useState([]);

    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( authenticated
        ? dbContacts
        : SampleAttendees);

    useEffect(() => {

        console.log("authenticated, dbContacts, SampleAttendees triggered ...");

        setAttendeesReferenceArray(
            authenticated
                ? dbContacts
                : SampleAttendees
        );
    }, [authenticated, dbContacts, SampleAttendees]);

    const [ idea, setIdea ] = useState(eventIdea);
    const [eventIdeaPhotos, setEventIdeaPhotos] = useState([]);


    useEffect(() => {
        // Find the specific version of this idea in the global store
        const globalIdea = PA_GlobalObject.Planning.ideas.find(i => i.id === idea.id);

        if (globalIdea) {
            // 2. Compare the content of the comments, not just the count
            const globalCommentsStr = JSON.stringify(globalIdea.comments);
            const localCommentsStr = JSON.stringify(idea.comments);

            if (globalCommentsStr !== localCommentsStr) {
                setIdea(globalIdea);
            }
        }
    }, [PA_GlobalObject.Planning.ideas, idea.id]);

    const [anchorIdeaItemMenu, setAnchorIdeaItemMenu] = useState(null);
    const handleIdeaListItemMenuOpenMenu = (event) => {
        setAnchorIdeaItemMenu(event.currentTarget);
    };
    const handleIdeaListItemMenuClose = () => {
        setAnchorIdeaItemMenu(null);
    };
    const handleIdeaListMenuClick = (event) => {
        const target = event.currentTarget;
        const dataId = target.getAttribute('data-id');

        setAnchorIdeaItemMenu(event.currentTarget);

        //add any of the Event attendees to the meal
        const attendees = usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees;


        if (dataId === "activities"){
            //add the new Activity
            const _new_activity = new Activity();
            _new_activity.title = idea.title;
            _new_activity.created_by = Account.id;

            if (attendees.length > 0) {
                _new_activity.attendees = attendees
                    .filter((att) => att.role !== 'planner' && att.role !== 'partial' && att.rsvp !== 'decline')
                    .map((att) => ({
                        id: att.id,
                        cost: 0,
                        is_business_expense: false,
                        business_expense_amount_authorized: 0,
                        business_expense_amount_authorized_by: "",
                        business_expense_amount_authorized_timestamp: 0,
                        business_expense_amount: 0,
                        business_expense_paid: 0,
                        business_expense_reference_id: "",
                    }));
            }

            _new_activity.location = idea.location;
            _new_activity.photos = idea.photos;
            _new_activity.Place = idea.Place;

            set_PA_GlobalObject((prev) => ({
                Planning: {
                    ...prev.Planning, // Retain all existing fields in Planning
                    activities: [...prev.Planning.activities, _new_activity],
                },
            }));

            setCurrentFeature("Activities");

            navigate('/Planner/Activities');

            //send to server
            if (PA_GlobalObject.Planning.status!== 10){
                const _sendString = {};
                _sendString.action = "E_addEventActivity_v2";
                _sendString.event_id = PA_GlobalObject.Planning.id;
                _sendString.activity = _new_activity;

                dataArray.Websocket.send(JSON.stringify(_sendString) + "|^");
            }


        } else if (dataId === "lodging"){
            //add the new Lodging
            const _new_lodging = new Lodging();

            _new_lodging.name = idea.title;
            _new_lodging.created_by = Account.id;

            if (attendees.length > 0) {
                _new_lodging.attendees = attendees
                    .filter((att) => att.role !== 'planner' && att.role !== 'partial' && att.rsvp !== 'decline')
                    .map((att) => ({
                        id: att.id,
                        cost: 0,
                        is_business_expense: false,
                        business_expense_amount_authorized: 0,
                        business_expense_amount_authorized_by: "",
                        business_expense_amount_authorized_timestamp: 0,
                        business_expense_amount: 0,
                        business_expense_paid: 0,
                        business_expense_reference_id: "",
                    }));
            }

            _new_lodging.location = idea.location;
            _new_lodging.photos = idea.photos;
            _new_lodging.Place = idea.Place;

            set_PA_GlobalObject((prev) => ({
                Planning: {
                    ...prev.Planning, // Retain all existing fields in Planning
                    lodging: [...prev.Planning.lodging, _new_lodging],
                },
            }));

            setCurrentFeature("Lodging");

            navigate('/Planner/Lodging');

            //send to server
            if (PA_GlobalObject.Planning.status!== 10){
                const _sendString = {};
                _sendString.action = "E_addEventLodging_v2";
                _sendString.event_id = PA_GlobalObject.Planning.id;
                _sendString.lodging = _new_lodging;

                dataArray.Websocket.send(JSON.stringify(_sendString) + "|^");
            }


        } else if (dataId === "meals"){
            //add the new Meal

            const _new_meal = new Meal();
            _new_meal.name = idea.title;
            _new_meal.created_by = Account.id;

            if (attendees.length > 0) {
                _new_meal.attendees = attendees
                    .filter((att) => att.role !== 'planner' && att.role !== 'partial' && att.rsvp !== 'decline')
                    .map((att) => ({
                        id: att.id,
                        cost: 0,
                        is_business_expense: false,
                        business_expense_amount_authorized: 0,
                        business_expense_amount_authorized_by: "",
                        business_expense_amount_authorized_timestamp: 0,
                        business_expense_amount: 0,
                        business_expense_paid: 0,
                        business_expense_reference_id: "",
                    }));
            }

            _new_meal.location = idea.location;
            _new_meal.photos = idea.photos;
            _new_meal.Place = idea.Place;

            set_PA_GlobalObject((prev) => ({
                Planning: {
                    ...prev.Planning, // Retain all existing fields in Planning
                    meals: [...prev.Planning.meals, _new_meal],
                },
            }));

            setCurrentFeature("Meals");

            navigate('/Planner/Meals');

            //send to server
            if (PA_GlobalObject.Planning.status!== 10){
                const _sendString = {};
                _sendString.action = "E_addEventMeal_v2";
                _sendString.event_id = PA_GlobalObject.Planning.id;
                _sendString.meal = _new_meal;

                dataArray.Websocket.send(JSON.stringify(_sendString) + "|^");
            }

        }

        handleIdeaListItemMenuClose();
    };

    const [openHoursDialog, setOpenHoursDialog] = useState(false);
    const handleClickOpenHoursDialog = () => {
        setOpenHoursDialog(true);
    };
    const handleCloseHoursDialog = () => {
        setOpenHoursDialog(false);
    };
    function HoursDialog({ open, handleClose, openingHours }) {
        return (
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Opening Hours</DialogTitle>
                <DialogContent>
                    {openingHours.weekday_text?.map((text, index) => (
                        <Typography key={index} variant="body1">
                            {text.replace('12:00 AM', 'Midnight').replace('12:00 PM', 'Noon')}
                        </Typography>
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    }

    const ideaCommentsScrollRef = useRef(null);
    useEffect(() => {
        if (ideaCommentsScrollRef.current) {
            const scrollContainer = ideaCommentsScrollRef.current;
            scrollContainer.scrollTo({
                top: scrollContainer.scrollHeight,
                behavior: 'smooth', // Use 'auto' for instant jump
            });        }
    }, [idea?.comments]);


    //function to add new comment
    const [newComment, setNewComment] = useState("");

    const handleAddComment = () => {
        if (!newComment.trim()) return;

        const newEntry = new IdeaComment();
        newEntry.attendee_id = Account.id;
        newEntry.comment = newComment;

        // 1. Update the local idea state
        const updatedIdea = {
            ...idea,
            comments: [...idea.comments, newEntry]
        };
        setIdea(updatedIdea);

        // 2. Update the Global Object directly
        set_PA_GlobalObject((prev) => ({
            ...prev,
            Planning: {
                ...prev.Planning,
                ideas: prev.Planning.ideas.map((_idea) =>
                    _idea.id === idea.id ? updatedIdea : _idea
                ),
            },
        }));

        // 3. Send to Server immediately
        if (PA_GlobalObject.Planning.status!== 10) {
            const _sendString = {
                action: "E_addEventIdeaComment",
                event_id: PA_GlobalObject.Planning.id,
                idea_id: idea.id,
                // Send only the new comment we just created
                comment: newEntry
            };
            sendSocketMessage(_sendString);
        }

        setNewComment("");
    };

    const handleDeleteIdea = () => {
        deleteEventIdea(idea.id);  // Trigger the delete confirmation from IdeaList
    };


    useEffect(() => {
        if (idea['location'].google_place_id && eventIdeaPhotos.length === 0) {
            fetchPlacePhotos(idea['location'].google_place_id);
        }
    }, [idea['location'].google_place_id]);

    const fetchPlacePhotos = async (placeId) => {
        // 1. Initialize the Place object
        const { Place } = await window.google.maps.importLibrary("places");
        const place = new Place({
            id: placeId,
        });

        // 2. Fetch only the 'photos' field
        // This is a Promise-based call, so we use 'await'
        try {
            await place.fetchFields({ fields: ['photos'] });

            if (place.photos && place.photos.length > 0) {
                const urls = place.photos.map(p => p.getURI({ maxWidth: 150, maxHeight: 150 }));
                console.log("urls : ", urls);
                setEventIdeaPhotos(urls);
            }
        } catch (error) {
            console.error("Error fetching place photos:", error);
        }
    };





    return (

        <Card
            sx={{
                borderRadius: '5px',
                border: '1px solid #f09637'
            }}
        >

            {/* add any photos if they exist */}
            {
                eventIdeaPhotos && eventIdeaPhotos.length >= 0 ? (
                    <div className="ideas-suggestions-add-list-item-photos">
                        <div className="horizontal-scroll-container">
                            {eventIdeaPhotos.map((url, index) => (
                                <CardMedia
                                    key={index}
                                    component="img"
                                    alt={`Photo ${index + 1}`}
                                    image={url} // Using the direct URL from state
                                />
                            ))}
                        </div>
                    </div>
                ) : (
                    <></>
                )
            }
            <CardHeader
                action={
                    <IconButton
                        aria-label="settings"
                        onClick={handleIdeaListItemMenuOpenMenu}
                    >
                        <i
                            className="icon-menu2"
                            style={{fontSize: '16px'}}
                        />
                    </IconButton>
                }
                sx={{
                    padding: idea['photos'] && idea['photos'].length > 0 ? '0 10px 0 10px':'10px 10px 0 10px',
                    "& .MuiCardHeader-title": {
                        fontSize: "1rem",  // Set font size for the title
                    },
                }}
                titleTypographyProps={{ fontSize: '18px' }}
            />
            <Menu
                sx={{ width: 320, maxWidth: '100%' }}
                anchorEl={anchorIdeaItemMenu}
                id="meal-item-menu"
                open={Boolean(anchorIdeaItemMenu)}
                onClose={handleIdeaListItemMenuClose}

                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuList
                    dense
                    sx={{ width: 320, maxWidth: '100%' }}
                >
                    <Typography sx={{px: 2, py: 1}} >
                        Add To
                    </Typography>
                    {[
                        { label: "Activities", icon: "icon-list-heart", id: "activities" },
                        { label: "Lodging", icon: "icon-bed", id: "lodging" },
                        { label: "Meals", icon: "icon-fork-knife2", id: "meals" },
                    ].map((option) => (
                        <MenuItem
                            key={option.id}
                            data-id={option.id}
                            onClick={handleIdeaListMenuClick}
                            sx={{ pl: 4 }}
                        >
                            <ListItemIcon>
                                <i className={option.icon} />
                            </ListItemIcon>
                            <ListItemText primary={option.label} />
                        </MenuItem>
                    ))}
                    <Divider sx={{ my: 1 }} />
                    <MenuItem
                        data-id="delete"
                        onClick={handleDeleteIdea}
                    >
                        <ListItemIcon sx={{color:'#F00'}}>
                            <i className="icon-trash" title="Delete"/>
                        </ListItemIcon>
                        <ListItemText>Delete</ListItemText>
                    </MenuItem>
                </MenuList>
            </Menu>

            <CardContent>
                <Typography variant="body2">
                    {idea['title']}
                </Typography>
                <Typography sx={{fontSize: '12px'}} color="text.secondary">
                    {idea['location'].address}
                </Typography>
                <Typography sx={{ fontSize:'12px' }} color="text.secondary">
                    {idea['location'].city} {idea['location'].state} {idea['location'].zip}
                </Typography>
                <Typography sx={{ mb: 1.5, fontSize:'12px' }} color="text.secondary">
                    {idea['phone']}
                </Typography>
                <Typography
                    component="div"
                    sx={{
                        mb: 1.5,
                        fontSize: '13px',
                        display: 'flex',
                        justifyContent: 'space-between', // Space between left and right items
                        alignItems: 'center'
                    }}
                    color="text.secondary"
                >
                    {/* Left side: Website (only if available) */}
                    {
                        idea['Place']?.website ? (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <i className="icon-earth" title="Website"
                                   style={{ marginRight: '10px', fontSize: '20px' }}
                                />
                                <a
                                    href={idea['Place'].website}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: 'inherit', textDecoration: 'none' }} // Optional: Keep the styling consistent
                                >
                                    Website
                                </a>
                            </div>
                        ) : (
                            <div /> // Placeholder if website is undefined to keep layout consistent
                        )
                    }

                    {/* Right side: Hours (show even if website is undefined) */}
                    {
                        idea['Place']?.opening_hours && (
                            <div
                                style={{cursor: 'pointer', color: '#1976d2'}}
                                onClick={handleClickOpenHoursDialog} // Open dialog on click
                            >
                                Hours
                            </div>
                        )
                    }
                </Typography>

                {/* Dialog to display all hours */}
                {
                    idea['Place']?.opening_hours && (
                        <HoursDialog
                            open={openHoursDialog}
                            handleClose={handleCloseHoursDialog}
                            openingHours={idea['Place'].opening_hours}
                        />
                    )
                }
            </CardContent>

            <CardContent sx={{ pb: '16px !important' }}>
                {/* 1. SCROLLABLE CONTAINER */}
                <Box
                    ref={ideaCommentsScrollRef}
                    sx={{
                        maxHeight: '300px',
                        overflowY: 'auto',
                        mb: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        pr: 1, // Space for scrollbar
                        // Custom Scrollbar Styling
                        '&::-webkit-scrollbar': { width: '6px' },
                        '&::-webkit-scrollbar-track': { background: 'transparent' },
                        '&::-webkit-scrollbar-thumb': { background: '#ddd', borderRadius: '10px' },
                        '&::-webkit-scrollbar-thumb:hover': { background: '#ccc' },
                    }}
                >
                    {idea?.comments
                        .filter(c => c.comment?.trim())
                        .map((comment, idx) => {
                            const attendee = PA_GlobalObject.Planning.attendees.find(a => a.id === comment.attendee_id);

                            const fullName = attendee.nickname?.trim()
                                ? `${formatName(attendee.nickname)}`
                                : `${formatName(attendee.fname)} ${formatName(attendee.lname)}`;

                            const isSelf = comment.attendee_id === Account.id;
                            const formattedDate = comment.created
                                ? dayjs(Number(comment.created)).format('MMM D, h:mm A')
                                : '';

                            return (
                                <Box
                                    key={idx}
                                    sx={{
                                        mb: 1.5,
                                        display: 'flex',
                                        justifyContent: isSelf ? 'flex-end' : 'flex-start',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            maxWidth: '75%',
                                            display: 'flex',
                                            flexDirection: isSelf ? 'row-reverse' : 'row',
                                            alignItems: 'flex-start',
                                            gap: 1,
                                            px: 1.25,
                                            py: 1,
                                            borderRadius: 2,
                                            ...(isSelf
                                                ? { bgcolor: 'rgb(179, 224, 247)', borderTopRightRadius: 0 }
                                                : { bgcolor: 'rgb(224, 247, 250)', borderTopLeftRadius: 0 }),
                                            width: 'fit-content',
                                        }}
                                    >
                                        <Tooltip title={fullName} arrow>
                                            {
                                                !attendee?.avatar || !attendee?.avatar.preview ? (
                                                    <Avatar
                                                        {...stringAvatar(`${formatName(attendee.fname)}, ${formatName(attendee.lname)}`)}
                                                        // Apply custom styles that were not globally overridden
                                                        sx={{
                                                            boxShadow: '' +
                                                                '0px 3px 1px -2px rgba(0, 0, 0, 0.2), ' +
                                                                '0px 2px 2px 0px rgba(0, 0, 0, 0.14), ' +
                                                                '0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
                                                            border: `1px solid ${stringToColor(`${formatName(attendee.fname)}, ${formatName(attendee.lname)}`)}`,
                                                            borderRadius: '10px',
                                                            textAlign: 'center',
                                                            fontWeight: '700',
                                                            backgroundColor: '#FFF',
                                                            color: 'black',
                                                            fontSize: '15px',
                                                            width: '30px',
                                                            height: '30px',
                                                        }}
                                                    />
                                                ) : (
                                                    <Avatar
                                                        src={attendee.avatar.preview}
                                                        // Apply custom styles that were not globally overridden
                                                        sx={{
                                                            boxShadow: '' +
                                                                '0px 3px 1px -2px rgba(0, 0, 0, 0.2), ' +
                                                                '0px 2px 2px 0px rgba(0, 0, 0, 0.14), ' +
                                                                '0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
                                                            border: `1px solid ${stringToColor(`${formatName(attendee.fname)}, ${formatName(attendee.lname)}`)}`,
                                                            borderRadius: '10px',
                                                            textAlign: 'center',
                                                            fontWeight: '700',
                                                            backgroundColor: '#FFF',
                                                            color: 'black',
                                                            fontSize: '15px',
                                                            width: '30px',
                                                            height: '30px',
                                                        }}
                                                    />
                                                )
                                            }

                                        </Tooltip>

                                        <Box sx={{ minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                            <Typography sx={{ fontSize: '13px', lineHeight: 1.4, wordBreak: 'break-word' }}>
                                                {comment.comment}
                                            </Typography>

                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    fontSize: '10px',
                                                    opacity: 0.75,
                                                    alignSelf: isSelf ? 'flex-end' : 'flex-start',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    maxWidth: '100%',
                                                }}
                                            >
                                                {formattedDate}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            );
                    })}
                </Box>

                {/* 2. INPUT AREA (STAYS AT BOTTOM) */}
                <Box sx={{ borderTop: '1px solid #eee', pt: 2 }}>
                    <TextField
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        label="Add a Comment"
                        variant="standard"
                        fullWidth
                        multiline
                        minRows={1}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault();
                                handleAddComment();
                            }
                        }}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mt: 1,
                        }}
                    >
                        <Button
                            color="primary"
                            size="small"
                            onClick={handleAddComment}
                            sx={{
                                bgcolor: "primary.main",
                                color: "white",
                                px: 2,
                                py: 0.5,
                                borderRadius: '18px',
                                textTransform: 'none',
                                fontWeight: 600,
                                "&:hover": { bgcolor: "primary.dark" },
                                boxShadow: 1,
                            }}
                        >
                            Post
                        </Button>
                    </Box>
                </Box>
            </CardContent>

        </Card>

    )
}

export default IdeasCard;
